import { render, staticRenderFns } from "./SurveyItemCheckbox.vue?vue&type=template&id=54857090&scoped=true&"
import script from "./SurveyItemCheckbox.vue?vue&type=script&lang=js&"
export * from "./SurveyItemCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54857090",
  null
  
)

export default component.exports